"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormReducer = void 0;
var _react = require("react");
const ACTION_TYPES = {
  SET: 'SET',
  INJECT: 'INJECT',
  CLEAR: 'CLEAR',
  RESET: 'RESET'
};
const useFormReducer = initialState => {
  const reducer = (state, action) => {
    switch (action.type) {
      case ACTION_TYPES.SET:
        return {
          ...state,
          [action.payload.key]: action.payload.value
        };
      case ACTION_TYPES.INJECT:
        return {
          ...state,
          ...action.payload
        };
      case ACTION_TYPES.CLEAR:
        return {
          ...state,
          [action.payload.key]: null
        };
      case ACTION_TYPES.RESET:
        return initialState;
      default:
        return state;
    }
  };
  const [state, dispatch] = (0, _react.useReducer)(reducer, initialState);
  return {
    state,
    dispatch,
    ACTION_TYPES
  };
};
exports.useFormReducer = useFormReducer;